import React from "react";
import { Box } from "@mui/material";
import { contentSx, contentWideSx } from "./styles";

function SettingsContent({ children, wide = false, sx }) {
  return (
    <Box sx={{ ...(wide ? contentWideSx : contentSx), ...sx }}>
      {children}
    </Box>
  );
}

export default SettingsContent;
